module.exports = __webpack_public_path__ + "img/1_02.fbd3ba74.jpg";